export default "__VITE_ASSET__7hRgIc1c__"